import { Store } from "@store";
import dynamic from "next/dynamic";
import Image from "next/legacy/image";
import { useRouter } from "next/router";
import React, { useContext, useEffect, useRef, useState } from "react";
import defaultProfilePic from "@public/assets/images/blank-profile-picture.png";
import { deleteBlog, dislikeBlogPost, likeBlogPost, reportBlogPost } from "@queries/blogs.queries";
import style from "../styles/singleBlogView.module.css";
import postClasses from "@styles/post/post.module.css";
import { HTTP_STATUS_CODES, UTSAV_ADMINS, WEB_ENGAGE } from "@utils/constants";
import { prettyDate, readingTime } from "@utils/metrics/timeFunction";
import classNames from "classnames/bind";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Divider, Menu, MenuItem, NoSsr, Typography } from "@mui/material";
import ReactHtmlParser from "html-react-parser";
import BlockedUserModal from "@components/modal/BlockedUserModal";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import UtsavNewModal from "src/globalModule/views/UtsavNewModal";
import BlogItem from "../components/blogItem";
import { trackEvent } from "@utils/analytics/event-analytics";
import { useDispatch, useSelector } from "react-redux";
import BlogRelatedEventCard from "../components/blogRelatedEventCard";
import GuestUserModal from "src/globalModule/components/guestUserModal";
import { setBlogLoginModal } from "@utils/reduxToolkit/features/userSlice";
import LiteYouTubeEmbed from "react-lite-youtube-embed";
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css";

/*---------------------- To be loaded at client-side only ---------------------------*/

// icons

const LikeIcon = dynamic(() => import("@public/assets/icons/likeIcon.svg"), {
  ssr: false
});
const LikedIcon = dynamic(() => import("@public/assets/icons/likedIcon.svg"), {
  ssr: false
});
// const CommentIcon = dynamic(() => import("@public/assets/icons/comment.svg"), {
//   ssr: false,
// });

const BlogShareOptions = dynamic(() => import("../components/BlogShareOptions"), {
  ssr: false
});
const BlogsF_Q = dynamic(() => import("../components/BlogsFAQ"), {
  ssr: false
});
const TopComment = dynamic(() => import("@components/comments/TopComment"), {
  ssr: false
});

// const AllComments = dynamic(() => import("@components/comments/AllComments"), {
//   ssr: false,
// });

// const WriteComment = dynamic(
//   () => import("@components/comments/WriteComment"),
//   {
//     ssr: false,
//   }
// );

const UtsavModal = dynamic(() => import("src/globalModule/components/UtsavModal"), {
  ssr: false
});

// const GuestPopup = dynamic(() => import("@components/modal/GuestPopup"), {
//   ssr: false,
// });

/*--------------------------- components end ------------------------------*/

function SingleBlogView(props) {
  // console.log("SingleBlogView", props.data);
  const {
    t
  } = useTranslation();
  const menuRef = useRef();
  const [menuEl, setMenuEl] = React.useState(null);
  const menubtnRef = useRef();
  const router = useRouter();
  const [isLiked, setIsLiked] = useState(props.data.mainBlog?.isLiked);
  const [likeCount, setLikeCount] = useState(props.data.mainBlog?.likeNo > 0 ? props.data.mainBlog?.likeNo : 0);
  const [cmtNo, setCmtNo] = useState(props.data.mainBlog?.commentNo ? props.data.mainBlog?.commentNo : 0);
  const [commentL, setcommentL] = useState(props.data.mainBlog?.comments ? props.data.mainBlog?.comments : []);
  const [videoID, setVideoID] = useState(props.data.mainBlog?.youtubeLink ? props.data.mainBlog?.youtubeLink.split("/").pop().split("?")[0] : null);
  const [openReportModal, setOpenReportModal] = useState(false);
  const [openMoreOptions, setOpenMoreOptions] = useState(false);
  const [repSuccessModal, setRepSuccessModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const [openBlockedUserModal, setOpenBlockedUserModal] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const toggleBlockedServiceModal = () => {
    setOpenBlockedUserModal(!openBlockedUserModal);
  };
  const smallScreen = useMediaQuery("(max-width:768px)");
  const [errorModal, setErrorModal] = useState({
    open: false,
    heading: "",
    message: "",
    acceptMethod: () => {},
    icon: null,
    positive: false
  });
  const {
    state
  } = useContext(Store);
  const dispatch = useDispatch();
  const loggedInUser = state.user;
  // console.log("loggedInUser", loggedInUser);
  const blogLoginModal = useSelector(state => state.userDetails)?.blogLoginModal;

  // console.log("blogLoginModal", blogLoginModal);

  // const [blogsArray, setBlogsArray] = useState([]);
  // const smallScreen = useMediaQuery(
  //   json2mq({
  //     maxWidth: 600,
  //   })
  // );

  const [hydrated, setHydrated] = useState(false);
  useEffect(() => {
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.BLOG_SCREEN + " " + WEB_ENGAGE.EVENT_NAMES.SCREEN_VIEWED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.BLOG_SCREEN,
      [WEB_ENGAGE.EVENT_PROPERTIES.BLOG_NAME]: props.data.mainBlog.headline
    });
  }, []);

  // Add event listener for scroll event
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [smallScreen, blogLoginModal]); // Empty dependency array means this effect runs once on mount and cleanup on unmount

  const handleScroll = () => {
    let scrollDepth = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight) * 100;
    scrollDepth = Math.round(scrollDepth);
    if (scrollDepth === 30 || scrollDepth === 80) {
      if (loggedInUser.accessToken == null && blogLoginModal === true) {
        const currentTime = new Date().getTime();
        let lastShownTime = null;
        if (typeof window !== "undefined") {
          try {
            lastShownTime = localStorage.getItem("lastShownTime");
          } catch (e) {
            console.log("error in local storage");
          }
        }
        if (!lastShownTime || currentTime - lastShownTime >= 180000) {
          setLoginModalOpen(true);
          try {
            localStorage.setItem("lastShownTime", currentTime);
          } catch (e) {
            console.log("error in local storage");
          }
        }
      }
    }
  };
  const handleBlogLoginModal = value => {
    setLoginModalOpen(value);
    if (value === false) dispatch(setBlogLoginModal(false));
  };
  useEffect(() => {
    document.addEventListener("mousedown", event => {
      if (menuRef.current !== undefined && menuRef.current !== null && menubtnRef.current !== undefined && menubtnRef.current !== null) {
        if (!menuRef.current.contains(event.target) && !menubtnRef.current.contains(event.target)) {
          setOpenMoreOptions(false);
        }
      }
    });

    // This forces a rerender, so the date is rendered
    // the second time but not the first
    setHydrated(true);
  }, []);

  // useEffect(() => {
  //   async function getData() {
  //     const { data } = await getPopularBlogPosts({ blogID: props.data.mainBlog?.blogID });
  //     if (data) {
  //       const array = data.filter((blog) => blog.blogID !== props.data.mainBlog?.blogID);
  //       // if (array) setBlogsArray(array.slice(0, 4));
  //       // else setBlogsArray(data.slice(0, 4));
  //       if (array && array.length > 0) setBlogsArray(array);
  //       else setBlogsArray(data);
  //     }
  //   }
  //   console.log("blog array data here ",blogsArray);

  //   getData();
  // }, [props.data.mainBlog.blogID]);

  if (!hydrated) {
    // Returns null on first render, so the client and server match
    return null;
  }
  const likeHandle = async event => {
    event.preventDefault();
    if (loggedInUser.accessToken == null) {
      // setOpenUnauthorizedModal(true);
      // if (smallScreen) setLoginModalOpen(true);
      setLoginModalOpen(true);
      return () => {};
    }
    if (isLiked) {
      const res = await dislikeBlogPost(props.data.mainBlog.blogID, loggedInUser.accessToken);
      if (res && !res.success && res.code === HTTP_STATUS_CODES.BLOCKED) {
        setErrorMsg(res.message);
        toggleBlockedServiceModal();
        return () => {};
      }
      setIsLiked(false);
      setLikeCount(likeCount - 1);
    } else {
      const res = await likeBlogPost(props.data.mainBlog.blogID, loggedInUser.accessToken);
      if (res && !res.success && res.code === HTTP_STATUS_CODES.BLOCKED) {
        setErrorMsg(res.message);
        toggleBlockedServiceModal();
        return () => {};
      }
      setIsLiked(true);
      setLikeCount(likeCount + 1);
    }
  };
  const cl = classNames.bind(postClasses);
  const likeIconStyles = {
    like: cl({
      post_icon: true,
      post_icon_like: true
    }),
    liked: cl({
      post_icon: true,
      post_icon_liked: true
    })
  };
  async function reportPost() {
    const res = await reportBlogPost(loggedInUser.uid, props.data.mainBlog.postID, loggedInUser.accessToken);
    if (res && !res.success && res.code === HTTP_STATUS_CODES.BLOCKED) {
      setErrorMsg(res.message);
      toggleBlockedServiceModal();
      return () => {};
    }
    toggleReportModal();
    toggleRepSuccessModal();
  }
  async function deletePost() {
    const response = await deleteBlog({
      blogID: props.data.mainBlog.blogID,
      accessToken: loggedInUser.accessToken
    });
    router.push("/blogs");
    toggleDeleteModal();
    if (response) {
      if (props.data.deleteBlogLocally) props.data.deleteBlogLocally(props.data.mainBlog.blogID);
    } else alert(`${t("something-went-wrong")}`);
  }
  async function deleteCommentLocally(id) {
    if (id && id !== "") {
      const array = commentL.filter(item => {
        if (item.commentID === id) {
          return null;
        } else return item;
      });
      setcommentL(array);
      setCmtNo(cur => cur - 1);
    }
  }
  const toggleDeleteModal = () => {
    setOpenDeleteModal(!openDeleteModal);
  };
  const toggleRepSuccessModal = () => {
    setRepSuccessModal(!repSuccessModal);
  };
  const toggleReportModal = () => {
    setOpenReportModal(!openReportModal);
  };
  const handleTogglePostOptions = () => {
    setOpenMoreOptions(!openMoreOptions);
  };
  function getPureText(htmlText) {
    let plainText = htmlText.length > 220 ? htmlText.slice(0, 220) + "..." : htmlText;
    return plainText;
  }
  function PostMoreOptions() {
    if (props.data.mainBlog.uid === loggedInUser.uid || loggedInUser.accessToken && loggedInUser.UserRole === UTSAV_ADMINS.UTSAV_ADMIN || loggedInUser.accessToken && loggedInUser.UserRole === UTSAV_ADMINS.BLOG_POSTERS) {
      return <Menu id="basic-menu" anchorEl={menuEl} open={openMoreOptions} onClose={handleTogglePostOptions} MenuListprops={{
        "aria-labelledby": "basic-button"
      }}>
          <MenuItem onClick={() => {
          handleTogglePostOptions();
          router.push(`/editblog/${props.data.mainBlog.urlExtension}`);
        }}>
            {t("edit-blog")}
          </MenuItem>
          <MenuItem onClick={() => {
          handleTogglePostOptions();
          toggleDeleteModal();
        }}>
            {t("delete-blog")}
          </MenuItem>
          {props.data.for !== "SingleBlogView" && <MenuItem onClick={() => {
          handleTogglePostOptions();
          router.push(`/blogs/${props.data.mainBlog.blogID}`);
        }}>
              {t("view-blog")}
            </MenuItem>}
        </Menu>;
    } else {
      return <Menu id="basic-menu" anchorEl={menuEl} open={openMoreOptions} onClose={handleTogglePostOptions} MenuListprops={{
        "aria-labelledby": "basic-button"
      }}>
          <MenuItem onClick={() => {
          handleTogglePostOptions();
          toggleReportModal();
        }}>
            {t("report-blog")}
          </MenuItem>
        </Menu>;
    }
  }

  // function addComment(data) {
  //   //console.log("add comment blog => ", data);
  //   if (
  //     data?.success === false &&
  //     data?.message === `${t("comment-contains-vulgar-words")}`
  //   ) {
  //     setErrorModal({
  //       open: true,
  //       heading: `${t("your-comment-contains-vulgar-words")}`,
  //       message: `${t("please-remove-them-and-try-again-0")}`,
  //       acceptMethod: () => setErrorModal({ ...errorModal, open: false }),
  //       icon: (
  //         <ErrorOutlineOutlinedIcon sx={{ fontSize: "3rem", color: "red" }} />
  //       ),
  //     });
  //   } else {
  //     const totalCommentData = {
  //       ...data,
  //       User: {
  //         name: loggedInUser.name,
  //         dp: loggedInUser.dp,
  //         gender: loggedInUser.gender,
  //         uid: loggedInUser.uid,
  //       },
  //       likeNo: 0,
  //       isLiked: false,
  //     };
  //     if (commentL.length === 0) setcommentL([totalCommentData]);
  //     else setcommentL([totalCommentData, commentL[0]]);
  //   }
  // }

  // function Comments(item, index) {
  //   return (
  //     <TopComment
  //       key={index.toString()}
  //       comment={item}
  //       postType={postType}
  //       type="blog"
  //       deleteCommentLocally={deleteCommentLocally}
  //     />
  //   );
  // }

  // function viewBlog(urlExtension) {
  //   if (urlExtension !== "" && urlExtension)
  //     router.push("/blog/" + urlExtension);
  // }

  return <div className={style.blogRoot} data-sentry-component="SingleBlogView" data-sentry-source-file="SingleBlogView.jsx">
      <div className={style.blogContainer}>
        <div className={style.singleBlogContainer}>
          <div>
            <Typography variant="h1" className={`${style.blogTitle} ${style.noCopy}`} data-sentry-element="Typography" data-sentry-source-file="SingleBlogView.jsx">
              {props.data.mainBlog.headline}
            </Typography>
            <div className={style.post__header}>
              <div className={style.post__header__left}>
                <div className={style.postAuthDetail}>
                  <div className={style.post__avatar__user}>
                    <NoSsr data-sentry-element="NoSsr" data-sentry-source-file="SingleBlogView.jsx">
                      <Image src={props.data.mainBlog?.User?.dp || defaultProfilePic} alt={`${props.data.mainBlog.User.name} ${t("dp")}`} width="20" height="20" objectFit="cover" className={style.authorImg} data-sentry-element="Image" data-sentry-source-file="SingleBlogView.jsx" />
                    </NoSsr>
                  </div>

                  <div>
                    <span className={`${style.blogAuthorName} underOnHover ${style.noCopy}`}>
                      {props.data.mainBlog.User.name}
                    </span>
                    <span className={style.blogHeaderDateInfo}>&bull;</span>
                    <span className={style.timestamp}>
                      {readingTime(props.data.mainBlog.text)}
                      <span> {t("min-read")}</span>
                    </span>
                  </div>
                </div>
                <div className={style.blogHeaderInfoContainer}>
                  <div className={style.blogMetaData}>
                    <div className={style.timestamp}>
                      {prettyDate(new Date(+props.data.mainBlog.ts), router.locale)}
                    </div>
                  </div>
                </div>
              </div>

              <div className={style.post__header__right}>
                {!smallScreen && <div className={style.post_more_options}>
                    <NoSsr>
                      <MoreVertIcon ref={menubtnRef} onClick={e => {
                    setMenuEl(e.currentTarget);
                    setOpenMoreOptions(!openMoreOptions);
                  }} />
                    </NoSsr>

                    {openMoreOptions && <PostMoreOptions />}
                  </div>}
              </div>
            </div>
            <div className={style.shareSmallDeive}>
              <BlogShareOptions blogID={props.data.mainBlog.blogID} headline={props.data.mainBlog.headline} urlExtension={props.data.mainBlog.urlExtension} data-sentry-element="BlogShareOptions" data-sentry-source-file="SingleBlogView.jsx" />
            </div>
            <div className={`${style.body} ${style.noCopy}`}>
              {ReactHtmlParser(props.data.mainBlog.text)}
            </div>
            {!props.data.mainBlog.Faqs?.length <= 0 ? <BlogsF_Q data={props.data.mainBlog.Faqs} /> : null}

            {videoID && <div className={style.youtubeVideoContainer}>
                <LiteYouTubeEmbed id={videoID} title="Utsav Puja Video" />
              </div>}

            <div className={style.post__options}>
              <div className={style.like}>
                {isLiked ? <LikedIcon className={likeIconStyles.liked} onClick={likeHandle} /> : <LikeIcon className={likeIconStyles.like} onClick={likeHandle} />}
                <p className={style.blogLikeCount}>
                  {likeCount > 0 ? likeCount : null}
                </p>
              </div>

              {/* // COMMNETS SECTION REMOVED */}
              {/* <div className={style.comment}>
                <div
                  className={`${style.post_icon} ${style.post_icon_comment}`}
                >
                  <CommentIcon className={style.commentIcon} />
                </div>
                <p className={style.blogCommentCount}>
                  {cmtNo > 0 ? cmtNo : null}
                </p>
               </div> */}
              {/* <div className={style.share}>
               {getOptionName("Share", 1)}
               <RWebShare
                data={{
                  // text: "" + props.data.data.txt,
                  url: postURL,
                  title: "Check out the Post on Utsav",
                }}
                sites={["whatsapp", "copy", "mail", "linkedin", "telegram"]}
                onClick={() => {}}
                className="profile-display__about--share"
               >
                <ShareIcon
                  className={`${style.post_icon} post_icon - share`}
                />
               </RWebShare>
               </div> */}
              {/* // COMMNETS SECTION REMOVED */}
            </div>
            {smallScreen && <BlogRelatedEventCard data={props.data.relatedEvents} />}
            {/* <div className={style.writeCommentContainer}>
              {props.data.for !== "SingleBlogView" ? (
                <WriteComment
                  feedID={props.data.data.blogID}
                  addComment={addComment}
                  viewFor="blog"
                />
              ) : (
                ""
              )}
             </div> */}
            {/* {props.data.for === "SingleBlogView" ? (
              <AllComments
                feedID={props.data.data.blogID}
                postType={postType}
                viewFor="blog"
                setCmtNo={setCmtNo}
                deleteCommentLocally={deleteCommentLocally}
              />
             ) : (
              <div className={style.commentsContainer}>
                <div className={style.commentContainer}>
                  {commentL?.map(Comments)}
                </div>
              </div>
             )} */}
          </div>

          <div className={style.blogRootShareContainer}>
            <BlogShareOptions blogID={props.data.mainBlog.blogID} headline={props.data.mainBlog.headline} urlExtension={props.data.mainBlog.urlExtension} relatedEvents={props.data.relatedEvents} data-sentry-element="BlogShareOptions" data-sentry-source-file="SingleBlogView.jsx" />
          </div>
          {/* ========== MODALS SECTION========== */}

          {isLoginModalOpen && <GuestUserModal isLoginModalOpen={isLoginModalOpen} setLoginModalOpen={setLoginModalOpen} handleBlogLoginModal={handleBlogLoginModal} />}

          {openDeleteModal && <UtsavModal open={openDeleteModal} toggleModal={toggleDeleteModal} heading={t("delete-blog-0")} message={t("are-you-sure-that-you-want-to-delete-the-blog")} acceptMsg={t("yes")} onAccept={deletePost} rejectMsg={t("no")} positive={false} />}

          {openReportModal && <UtsavModal open={openReportModal} toggleModal={toggleReportModal} heading={t("report-blog-0")} message={t("do-you-really-want-to-report-the-blog")} acceptMsg={t("yes")} onAccept={reportPost} rejectMsg={t("no")} positive={false} />}

          {repSuccessModal && <UtsavModal open={repSuccessModal} toggleModal={toggleRepSuccessModal} heading={t("blog-reported")} message={t("the-blog-has-beed-reported")} acceptMsg={t("okay")} />}

          {openBlockedUserModal && <BlockedUserModal open={openBlockedUserModal} toggleModal={toggleBlockedServiceModal} message={errorMsg} acceptMsg={t("contact-utsav")} rejectMsg={t("cancel")} positive={false} />}

          {errorModal.open && <UtsavNewModal open={errorModal.open} toggleModal={() => setErrorModal(prevState => ({
          ...prevState,
          open: true
        }))} heading={errorModal.heading} message={errorModal.message} acceptMsg={t("okay")} onAccept={errorModal.acceptMethod}
        // rejectMsg="Cancel"
        icon={errorModal.icon} positive={errorModal.positive} />}
        </div>

        <Divider className={style.divider} sx={{
        opacity: 0.5
      }} data-sentry-element="Divider" data-sentry-source-file="SingleBlogView.jsx" />

        {props.data.relatedBlogs?.length > 0 && <>
            <div className={style.popularBlogsheading}>
              <span>{t("Related Blogs")}</span>
            </div>
            <div className={style.blogListContainer}>
              {props.data.relatedBlogs?.map((item, index) => {
            return <div key={index} className={style.cardInnerContainer}>
                    <BlogItem data={item} />
                  </div>;
          })}
              {/* {blogsArray.map((item)=>(
                <BlogDataCard data={item} key={item.blogID}/>
               ))} */}
            </div>
          </>}
      </div>
    </div>;
}
export default SingleBlogView;